import {SyncUIActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/SyncUIActDecorator';
import { slotStore} from '@gongxigames/framework/slotV2/globals';
import {QUICK_SKIP_THRESHOLD_FOR_TURBO_POPUP_SUGGESTION} from '@gongxigames/framework/slotV2/types';
import {
    listenUIDisabled,
    listenUIFeatureStarted,
    setAutoplaySpinsToZero
} from '@gongxigames/framework/slotV2/ui/acts/utils';
import {SlotSettings} from '@gongxigames/framework/slot';

export class AutoplaySpinUIAct extends SyncUIActDecorator {
    public execute(): void {
        this.updateAutoplayOptions();
        this.emitter.emit('General.disableSpinButton');
        this.emitter.emit('UI.updateUIElementsState', 'AutoplaySpinUIState');

        this.emitter.on('UI.stopAutoplayButton.pressed', () => {
            slotStore.isAutoplayStop.value = true;
            setAutoplaySpinsToZero();
            this.onExecuted?.();
        });
        this.emitter.on('Game.command.idle.activated', () => {
            this.onExecuted?.();
        });

        listenUIFeatureStarted(this, this.settings as SlotSettings);
        listenUIDisabled(this);

        this.emitter.on('UI.quickStopButton.pressed', this.onSkipStartedByButton.bind(this));

        this.eventManager.emit('Autoplay.START_SPIN');
        this.eventManager.on('Autoplay.STOP', () => {
            setAutoplaySpinsToZero();
            this.onExecuted?.();
        }, this);
    }

    protected updateAutoplayOptions(): void {
        const autoplayOptions = slotStore.autoplayOptions.value;

        if (autoplayOptions?.autoplaySpins) {
            slotStore.batchUpdate({autoplayOptions: {
                ...autoplayOptions,
                autoplaySpins: autoplayOptions?.autoplaySpins - 1
            }});
        }
    }

    protected onSkipStartedByButton(): void {
        // TODO understand, do we need 'UI.command.skip', everything works with only 'UI.command.spin' properly
        // this.emitter.emit('UI.command.skip');
        this.emitter.emit('UI.command.spin');

        if (slotStore.logic_nextActionIsSpin.value) {
            slotStore.countOfSkipButtonPressed.value++;
        }

        if(slotStore.countOfSkipButtonPressed.value === QUICK_SKIP_THRESHOLD_FOR_TURBO_POPUP_SUGGESTION) {
            slotStore.countOfSkipButtonPressed.value = 0;
            this.emitter.emit('UI.showTurboModeHint');
        }
    }

    getName(): string {
        return 'AutoplaySpinUIAct';
    }
}